import { render, staticRenderFns } from "./TechSupportForm.vue?vue&type=template&id=574b662d&lang=pug"
import script from "./TechSupportForm.vue?vue&type=script&lang=js"
export * from "./TechSupportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports